import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import { Paper, Grid, Typography } from "@mui/material";
import * as request from 'superagent';
import AppView from '~common/components/app-view/index';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import MFAMethodSelect from "../components/mfa-method-select"
import MFAEmailSetup from "../components/mfa-email-setup"
import MFAAuthenticatorSetup from "../components/mfa-authenticator-setup"
import PortalUserContext from '~common/lib/portal-user-context';
import ConfirmYesNo from "~common/components/modal/yes-no-modal"

const styles = (theme: Theme): StyleRules => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  paper: {
    width: 740,
    padding: 30,
    backgroundColor: "white",
  },
  textField: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}

const MFASetup: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {
  const { classes }: { classes: ClassNameMap } = props;

  const [status, setStatus] = useState("loading");
  const [method, setMethod] = useState({});
  const [error, setError] = useState(null);
  const [alreadyVerified, setAlreadyVerified] = useState(undefined);
  const [userIneligible, setUserIneligible] = useState(undefined);
  const [qr, setQR] = useState(undefined);
  const [setupCode, setSetupCode] = useState(undefined);
  const [enrollSuccess, setEnrollSuccess] = useState(undefined);
  const [confirmUnEnroll, setConfirmUnEnroll] = useState(undefined)

  const confirmRemoveMFA = () => {
    setConfirmUnEnroll(true)
  }

  const cancelConfirmRemoveMFA = () => {
    setConfirmUnEnroll(false)
  }

  useEffect(() => {
    var {mfaEnabled} = (window as any).App
    if (mfaEnabled !== true) {
      setStatus("disabled")
    } else {
      request.get("/api/auth/users/init-otp-enroll")
        .then((response: request.Response) => {
          if (response.body.alreadyVerified) {
            setStatus("ready");
            setAlreadyVerified(true);
          } else  {
            if (response.body.userIneligible) {
              setStatus("ready");
              setUserIneligible(true);
            } else {
              if (response.body.qr) {
                setQR(response.body.qr);
                setSetupCode(response.body.key);
              }
              setStatus("ready");
            }
          }
        })
        .catch((err) => {
          handleAPIError(err);
        });
    }
  }, []);

  const onErrorViewClose = () => {
    setError(null);
  };

  const handleAPIError = (err: any) => {
    setError(err);
  };

  const handleMethodChange = (method: string) => {
    setMethod(method);
  };

  const unEnroll = () => {
    request.put("/api/auth/users/otp-un-enroll").then(()=>{
      window.location.reload()
    }).catch((err)=>{
      handleAPIError(err);
    })
    
  }

   const goDashboard = () => {
      window.location.href = "/"
   }

   const goPreferences = () => {
    window.location.href = "/preferences"
 }

  const onSetupSuccess = () => {
    setEnrollSuccess(true)
  }

  let errorView;
  if (error) {
    errorView = <ErrorView classes={{}} error={error} onClose={onErrorViewClose} />;
  }

  if (enrollSuccess) {
    return (
      <AppView history={props.history}>
        <div className={classes.container}>
          <Paper className={classes.paper}>
            <Grid container spacing={8}>
              <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography style={{ textAlign: "center" }} variant="subtitle1">
                  You have succesfully enrolled for multi-factor authentication.
                </Typography>
                <Typography style={{ textAlign: "center" }} variant="subtitle1">
                    Click <a style={{cursor: "pointer", color: "blue"}} onClick={goDashboard}>here</a> to be taken to the dashboard.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </div>
    </AppView>
    )
  }

  var confirmModal: any;
  if (confirmUnEnroll) {
        confirmModal = (
            <ConfirmYesNo
              title={"Confirm MFA Un-Enroll"}
              confirmMessage={"Are you sure want remove multi-factor authentication?"}
              open={true}
              handleYes={unEnroll}
              handleNo={cancelConfirmRemoveMFA}
        />
        )
  }

  switch (status) {
    case 'loading':
      return (
        <AppView history={props.history}>
          <div className={classes.container}>
            {errorView}
            <LoadingView classes={{}} />
          </div>
        </AppView>
      );
    case 'disabled':
      return (
        <AppView history={props.history}>
          <div className={classes.container}>
            <Paper className={classes.paper}>
              <Grid container spacing={8}>
                  <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography style={{ textAlign: "center" }} variant="subtitle1">
                      You cannot enroll for multi-factor authentication at this time. 
                    </Typography>
                  </Grid>
                </Grid>
            </Paper>
          </div>
        </AppView>
      );
    case 'ready':
      return (
        <AppView history={props.history}>
          {errorView}
          {confirmModal}
          <div className={classes.container}>
            <Paper className={classes.paper}>

              {alreadyVerified &&
                <Grid container spacing={8}>
                  <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography style={{ textAlign: "center" }} variant="subtitle1">
                      You have already enrolled for multi-factor authentication.
                    </Typography>
                    <Typography style={{ textAlign: "center" }} variant="subtitle1">
                     Click <a style={{cursor: "pointer", color: "blue"}} onClick={confirmRemoveMFA}>here</a> to un-enroll.
                    </Typography>
                  </Grid>
                </Grid>
              }

              {userIneligible &&
                <Grid container spacing={8}>
                  <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography style={{ textAlign: "center" }} variant="subtitle1">
                      You are not eligible to enroll for multi-factor authentication.
                    </Typography>
                  </Grid>
                </Grid>
              }

              {!alreadyVerified && !userIneligible && <div>
                
                <Grid container spacing={8}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography style={{}} variant="subtitle1">
                      You are about to enroll for multi-factor authentication.
                    </Typography>
                  </Grid>
                </Grid>

                <div style={{marginTop: 10}}></div>
                
                <MFAMethodSelect value={method} onChange={handleMethodChange} />

                {method == "Email" && <MFAEmailSetup userName={PortalUserContext._userContext.userName} onSetupSuccess={onSetupSuccess}/>}

                {method == "Authenticator" && <MFAAuthenticatorSetup userName={PortalUserContext._userContext.userName} qr={qr} setupCode={setupCode} onSetupSuccess={onSetupSuccess} />}

                </div>
              }

            </Paper>
          </div>
        </AppView>
      );

    default:
      return null;
  }
};

export default withStyles(styles)(MFASetup);